import actions from './actions';
import mutations from './mutations';

const state = {
  qna_config: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
